/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';

//获取字典数据项值列表--dictionaryId
export function dataitemList(param) {
	return request(`${config.server}/api/v1/dms/dictionayDependent/list?${objectSerial(param)}`);
}

//获取字典数据项值列表--dependentItemId
export function dependentItemIdList(param) {
	return request(`${config.server}/api/v1/dms/dictionayDependent/dependentList?${objectSerial(param)}`);
}

//数据项值查看--传id
export function dataitemDetail(param) {
	return request(`${config.server}/api/v1/dms/dictionayDependent/detail?${objectSerial(param)}`);
}


//修改数据项值
/*
 *{
 active (integer, optional): 有效性（1有效，0失效） ,
 dependentDataItemId (integer, optional): 从属数据项id ,
 dependentDataItemValue (string, optional): 从属数据项值 ,
 description (string, optional): 描述 ,
 dictionaryId (integer, optional): 数据项id ,
 id (integer, optional): 主键ID ,
 ids (Array[integer], optional),
 itemselector (Array[integer], optional),
 name (string, optional): 数据项值名称 ,
 removeFlag (integer, optional): 软删除标识（0：未删除，1已删除） ,
 reqType (integer, optional): 访问类型 ,
 sKey (string, optional): 数据项值key ,
 sortOrder (integer, optional): 排序
 }
 * */
export function dataitemModify(param) {
	return request(`${config.server}/api/v1/dms/dictionayDependent/modify`,{
		method: 'post',
		body: param
	});
}


//新增数据项值
/*
 *{
 active (integer, optional): 有效性（1有效，0失效） ,
 dependentDataItemId (integer, optional): 从属数据项id ,
 dependentDataItemValue (string, optional): 从属数据项值 ,
 description (string, optional): 描述 ,
 dictionaryId (integer, optional): 数据项id ,
 id (integer, optional): 主键ID ,
 ids (Array[integer], optional),
 itemselector (Array[integer], optional),
 name (string, optional): 数据项值名称 ,
 removeFlag (integer, optional): 软删除标识（0：未删除，1已删除） ,
 reqType (integer, optional): 访问类型 ,
 sKey (string, optional): 数据项值key ,
 sortOrder (integer, optional): 排序
 }
 * */
export function dataitemAdd(param){
	return request(`${config.server}/api/v1/dms/dictionayDependent/insert`,{
		method: 'post',
		body: param
	});
}


//删除数据项值--传id
export function dataitemDelete(id){
	return request(`${config.server}/api/v1/dms/dictionayDependent/delete`,{
		method: 'post',
		body: id
	});
}

//获取字典数据项值列表--数据项sKey
export function sKeylist(param) {
  // return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist?${objectSerial(param)}`, {
  return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist`, {
  	body: param
	});
}



// WEBPACK FOOTER //
// ./src/service/dictionary/dataitem.js